import { useMemo } from 'react';
import { useProfileV2 } from '../Profile';
import { useFlagsStatus } from './useFlag';
import { useLearningMarketFlags } from './useLearningMarketFlags';
import { useCountries } from './useCountries';

export const useLearningMarkets = () => {
  const enabledMarkets = useLearningMarketFlags();
  const { flagsReady, flagsError } = useFlagsStatus();
  const { basicProfile, error: profileError } = useProfileV2();
  const { supportedCountryCodes } = useCountries();
  const marketsError = flagsError || (!basicProfile && !!profileError);
  const marketsLoading = !marketsError && (!flagsReady || !basicProfile);
  const markets = useMemo(
    () => supportedCountryCodes.filter((market) => enabledMarkets[market]),
    [supportedCountryCodes, enabledMarkets],
  );

  return {
    markets,
    marketsLoading,
    marketsError,
    hasAvailableMarket: !marketsLoading && !marketsError && markets.length > 0,
  };
};
